import React from 'react';

export function CocktailIcon({ size = 24, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M3 4h18l-9 10L3 4z" fill="currentColor" fillOpacity="0.18" />
      <path d="M3 4h18l-9 10L3 4z" />
      <path d="M12 14v6" />
      <path d="M8 21h8" />
      <circle cx="17" cy="3.5" r="0.9" fill="currentColor" />
    </svg>
  );
}
